module.exports = __webpack_public_path__ + "static/media/Haze.e466aa49.svg";